import React from 'react';
import {
  Popover,
  OverlayTrigger
} from 'react-bootstrap';

const KnowledgeBaseLink = () => (
  <OverlayTrigger
    trigger={['hover', 'focus']}
    placement="right"
    shouldUpdatePosition={true}
    overlay={
      <Popover id='popover-of-form'>
        To learn more about using our Advanced Search, please read our Knowledge Base
      </Popover>
    }
  >
    <a style={{ float: 'right' }}
      href="http://support.courtdrive.com/hc/en-us/articles/205450048-How-do-I-search-across-cases-using-keywords-and-filters-"
      target="_blank"
    >
      <span className="ir-tooltip" /> Learn more
    </a>
  </OverlayTrigger>
);

export default KnowledgeBaseLink;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/KnowledgeBaseLink.js